var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootcampjsmodality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_1649)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_158_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9128 1.3501C18.4559 1.35009 19.6658 1.35009 20.6382 1.42954C21.6284 1.51044 22.4464 1.6779 23.1868 2.05515C24.4039 2.67533 25.3935 3.66492 26.0137 4.8821C26.391 5.62249 26.5584 6.44049 26.6393 7.43065C26.7188 8.40299 26.7188 9.61284 26.7188 11.1559V11.2317C26.7188 12.7747 26.7188 13.9847 26.6393 14.957C26.5584 15.9472 26.391 16.7652 26.0137 17.5056C25.3935 18.7228 24.4039 19.7124 23.1868 20.3325C22.4464 20.7098 21.6284 20.8773 20.6382 20.9582C19.6659 21.0376 18.456 21.0376 16.9129 21.0376H14.3438V23.1008C15.0462 23.1499 15.7453 23.2605 16.4332 23.4324L18.2046 23.8753C18.6567 23.9883 18.9316 24.4464 18.8186 24.8985C18.7055 25.3506 18.2474 25.6254 17.7954 25.5124L16.0239 25.0695C15.1953 24.8624 14.3477 24.7588 13.5 24.7588C12.6523 24.7588 11.8047 24.8624 10.9761 25.0695L9.20464 25.5124C8.75256 25.6254 8.29446 25.3506 8.18144 24.8985C8.06842 24.4464 8.34328 23.9883 8.79536 23.8753L10.5668 23.4324C11.2547 23.2605 11.9538 23.1499 12.6562 23.1008V21.0376H10.0872C8.5441 21.0376 7.33415 21.0376 6.3618 20.9582C5.37164 20.8773 4.55365 20.7098 3.81325 20.3325C2.59608 19.7124 1.60648 18.7228 0.986302 17.5056C0.609051 16.7652 0.441588 15.9472 0.360689 14.957C0.281241 13.9847 0.281245 12.7748 0.28125 11.2316V11.1561C0.281245 9.61291 0.281241 8.40304 0.360689 7.43065C0.441588 6.44049 0.609051 5.62249 0.986302 4.8821C1.60648 3.66492 2.59608 2.67533 3.81325 2.05515C4.55365 1.6779 5.37164 1.51044 6.3618 1.42954C7.3342 1.35009 8.54406 1.35009 10.0872 1.3501H16.9128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9128 1.3501C18.4559 1.35009 19.6658 1.35009 20.6382 1.42954C21.6284 1.51044 22.4464 1.6779 23.1868 2.05515C24.4039 2.67533 25.3935 3.66492 26.0137 4.8821C26.391 5.62249 26.5584 6.44049 26.6393 7.43065C26.7188 8.40299 26.7188 9.61284 26.7188 11.1559V11.2317C26.7188 12.7747 26.7188 13.9847 26.6393 14.957C26.5584 15.9472 26.391 16.7652 26.0137 17.5056C25.3935 18.7228 24.4039 19.7124 23.1868 20.3325C22.4464 20.7098 21.6284 20.8773 20.6382 20.9582C19.6659 21.0376 18.456 21.0376 16.9129 21.0376H14.3438V23.1008C15.0462 23.1499 15.7453 23.2605 16.4332 23.4324L18.2046 23.8753C18.6567 23.9883 18.9316 24.4464 18.8186 24.8985C18.7055 25.3506 18.2474 25.6254 17.7954 25.5124L16.0239 25.0695C15.1953 24.8624 14.3477 24.7588 13.5 24.7588C12.6523 24.7588 11.8047 24.8624 10.9761 25.0695L9.20464 25.5124C8.75256 25.6254 8.29446 25.3506 8.18144 24.8985C8.06842 24.4464 8.34328 23.9883 8.79536 23.8753L10.5668 23.4324C11.2547 23.2605 11.9538 23.1499 12.6562 23.1008V21.0376H10.0872C8.5441 21.0376 7.33415 21.0376 6.3618 20.9582C5.37164 20.8773 4.55365 20.7098 3.81325 20.3325C2.59608 19.7124 1.60648 18.7228 0.986302 17.5056C0.609051 16.7652 0.441588 15.9472 0.360689 14.957C0.281241 13.9847 0.281245 12.7748 0.28125 11.2316V11.1561C0.281245 9.61291 0.281241 8.40304 0.360689 7.43065C0.441588 6.44049 0.609051 5.62249 0.986302 4.8821C1.60648 3.66492 2.59608 2.67533 3.81325 2.05515C4.55365 1.6779 5.37164 1.51044 6.3618 1.42954C7.3342 1.35009 8.54406 1.35009 10.0872 1.3501H16.9128Z",
    stroke: "url(#paint0_linear_158_1649)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_158_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6562 16.8189C12.6562 17.2848 13.034 17.6626 13.5 17.6626L20.25 17.6626C20.716 17.6626 21.0937 17.2848 21.0937 16.8189C21.0937 16.3529 20.716 15.9751 20.25 15.9751L13.5 15.9751C13.034 15.9751 12.6562 16.3529 12.6562 16.8189ZM9 16.8189C9 17.4402 8.49632 17.9439 7.875 17.9439C7.25368 17.9439 6.75 17.4402 6.75 16.8189C6.75 16.1975 7.25368 15.6938 7.875 15.6938C8.49632 15.6938 9 16.1975 9 16.8189Z",
    fill: "#062A6A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_158_1649",
    x: -24.4688,
    y: -23.3999,
    width: 75.9375,
    height: 73.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_158_1649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_158_1649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_158_1649",
    x: 3.75,
    y: 12.6938,
    width: 30.3438,
    height: 18.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_1649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_1649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_1649",
    x1: 0.28125,
    y1: 1.3501,
    x2: 24.388,
    y2: 27.6724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_1649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjsmodality);
export default __webpack_public_path__ + "static/media/Bootcamp js modality.bb931acc1d0608d52cee503651df995c.svg";
export { ForwardRef as ReactComponent };